import React from 'react';
import WorkspaceModal from './WorkspaceModal';
import ManageWorkspacesModal from './ManageWorkspacesModal';
import { deleteSpace, editSpace, newSpace, orderSpaces } from '../../scope/docSpaceActions';

/**
 * New space / Manage spaces (card 4.3): the Documents workspace modals, fed
 * the active project's spaces and the space actions. `dialog` is 'new' |
 * 'manage' | null.
 */
export default function SpaceDialogs({ dialog, setDialog, docSpaces }) {
  const { project, spaces, members } = docSpaces;
  if (!project || !dialog) return null;
  const warn = (err) => console.warn('[project-scope] space change failed:', err);
  if (dialog === 'new') {
    return (
      <WorkspaceModal
        ns="docSidebar.spaces"
        onClose={() => setDialog(null)}
        onSubmit={async (fields) => {
          try {
            await newSpace(project, fields, spaces.length);
            setDialog(null);
            return true;
          } catch (err) {
            warn(err);
            return false;
          }
        }}
      />
    );
  }
  return (
    <ManageWorkspacesModal
      workspaces={spaces}
      onClose={() => setDialog(null)}
      actions={{
        update: (id, fields) =>
          editSpace(project, spaces.find((s) => s.id === id), fields).then(
            () => true,
            (err) => {
              warn(err);
              return false;
            }
          ),
        reorder: (ids) => orderSpaces(project, spaces, ids).catch(warn),
        remove: (space) => deleteSpace(project, space, members).catch(warn),
      }}
      ns="docSidebar.spaces"
    />
  );
}
